import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { changeCategory } from '../../actions/post';
import { CategoryListPanel } from './CategoryListPanel';
import { getCategoryDisplayName } from '../../lib/PostUtils';
import * as KEY from '../../constants/keyCode';

function DefaultCategorySelect ({ label }) {
  return (
    <div className="btn-category" role="button">
      <div className="default-label">{label}</div>
    </div>
  );
}

function PostCategorySelect () {
  const categoryId = useSelector(state => state.post.newPost.category);
  const categories = useSelector(state => state.blog.categories);
  const dispatch = useDispatch();

  const [openCategory, setOpenCategory] = useState(false);
  const [selectedIdx, setSelectedIdx] = useState(0);

  const rootElm = useRef(null);
  const menuRef = useRef(null);
  const openBtnRef = useRef(null);

  function handleSelectCategory (categoryId, viewChannel) {
    setOpenCategory(false);
    dispatch(changeCategory(categoryId, viewChannel));
    setTimeout(() => openBtnRef.current.focus());
  }

  function handleToggleCategory () {
    setOpenCategory(!openCategory);
    if (!openCategory) {
      setSelectedIdx(0);
      setTimeout(() => menuRef.current.childNodes[0].focus());
    }
  }

  function selectedCategoryName () {
    let selected = categories.find(c => c.id == categoryId);
    if (!selected) {
      selected = categories
        .flatMap(c => (c.children ? c.children : []))
        .find(c => c && c.id == categoryId);
    }

    if (selected && selected.id > 0) {
      return getCategoryDisplayName(selected);
    } else {
      return '카테고리';
    }
  }

  function handleKeyDownOnMenu ({ keyCode }) {
    const menuItems = menuRef.current.childNodes;
    const len = menuItems.length;

    switch (keyCode) {
      case KEY.ARROW_DOWN:
        const nextIdx = (selectedIdx + 1) % len;
        setSelectedIdx(nextIdx);
        menuItems[nextIdx].focus();
        break;
      case KEY.ARROW_UP:
        const prevIdx = (selectedIdx + len - 1) % len;
        setSelectedIdx(prevIdx);
        menuItems[prevIdx].focus();
        break;
      case KEY.ENTER: case KEY.SPACE:
        const menuItem = menuItems[selectedIdx];
        const id = menuItem.getAttribute('category-id');
        const viewChannel = menuItem.getAttribute('view-channel');
        handleSelectCategory(id, viewChannel);
        break;
      case KEY.ESC:
        setOpenCategory(false);
        openBtnRef.current.focus();
        break;
      case KEY.TAB:
        setOpenCategory(false);
        break;
    }
  }

  let timeoutId = null;

  function handleFocus () {
    clearTimeout(timeoutId);
  }

  function handleBlur () {
    timeoutId = setTimeout(() => setOpenCategory(false));
  }

  return (
    <div onFocus={handleFocus} onBlur={handleBlur} ref={rootElm} className="btn-category" role="button">
      <div className={classnames('mce-widget mce-btn', { 'mce-opened': openCategory })}>
        <button type="button" ref={openBtnRef} onClick={handleToggleCategory}
          aria-haspopup="true" aria-expanded={openCategory}>
          <i className="mce-txt">{selectedCategoryName()}</i>
          <i className="mce-caret">더보기</i>
        </button>
      </div>

      {openCategory && (
        <CategoryListPanel
          selectedIdx={selectedIdx}
          setSelectedIdx={setSelectedIdx}
          menuRef={menuRef}
          handleKeyDownOnMenu={handleKeyDownOnMenu}
          categories={categories}
          onSelect={handleSelectCategory}
        />
      )}
    </div>
  );
}

export default function CategorySelect () {
  switch (window.Config.postType) {
    case 'page':
      return <DefaultCategorySelect label='페이지' />;
    case 'notice':
      return <DefaultCategorySelect label='공지사항' />;
    case 'keyword':
      return <DefaultCategorySelect label='키워드' />;
    case 'template':
      return <DefaultCategorySelect label='서식' />;
    case 'post':
    default:
      return <PostCategorySelect />;
  }
}
